/* MM / Contrôles slider — assets/mm-slider-controls.js
   Relais générique : chaque flèche émet 'mm:slider:prev' / 'mm:slider:next'
   sur l'élément ciblé par data-slider-target (le JS du slider écoute et
   avance). Délégation d'événements : marche pour toute flèche présente au
   clic, y compris ajoutée après coup. */
   (function () {
	'use strict';
  
	/* ---- Enfoncement puis rebond ------------------------------------------
	   Deux temps, deux techniques, et ce n'est pas un caprice :
  
	   1. TENU — tant que le doigt appuie, la flèche reste enfoncée. C'est un
		  ÉTAT, porté par une classe : rien à interrompre, un nouvel appui
		  retombe simplement dans le même état.
	   2. RELÂCHÉ — le retour est un ressort joué en JS. C'est lui qui se faisait
		  arracher quand il vivait en transition CSS : le clic suivant repartait
		  de la valeur courante, en pleine remontée. Ici un nouvel appui l'annule
		  franchement au lieu de le tordre — c'est un geste neuf, pas une
		  coupure.
  
	   Durées et courbes viennent des JETONS du kit, lus sur l'élément : le
	   ressort du kit (--mm-curve-big) dépasse la cible avant de se poser, donc
	   deux keyframes suffisent à faire un vrai rebond, sans sommet écrit à la
	   main. */
	/* Profondeur d'enfoncement : lue dans la MÊME variable que le CSS. Elle
	   était écrite en dur ici alors que la feuille utilise
	   var(--mm-slider-arrow-press, 0.9) — un thème qui l'aurait ajustée aurait
	   vu l'enfoncement changer sans que le ressort suive. Le Bouton lit déjà la
	   sienne de cette façon. */
	var PRESSE_REPLI = 0.9;
  
	function jeton(el, nom, repli) {
	  var v = getComputedStyle(el).getPropertyValue(nom).trim();
	  return v || repli;
	}
	/* les jetons sont en ms, mais un thème peut écrire « .65s » */
	function enMs(v, repli) {
	  var n = parseFloat(v);
	  if (!isFinite(n)) return repli;
	  return (v.indexOf('ms') === -1 && v.indexOf('s') !== -1) ? n * 1000 : n;
	}
  
	function enfoncer(el) {
	  var anim = el.__mmRebond;
	  if (anim) { anim.cancel(); el.__mmRebond = null; }
	  el.classList.add('is-pressed');
	}
  
	function relacher(el) {
	  if (!el.classList.contains('is-pressed')) return;
	  el.classList.remove('is-pressed');
	  if (!el.animate) return;
	  /* Ressort ADDITIF : il ne VISE pas une échelle, il n'est qu'un
		 multiplicateur qui s'éteint (fin à scale(1), l'identité). L'état de
		 repos reste donc au CSS et peut bouger sous lui — perdre le survol en
		 cours de route devient une transition composée avec le ressort au lieu
		 d'être contredite, et il n'y a rien à rendre à la fin, donc aucun saut.
		 La flèche n'a aujourd'hui pas d'échelle de survol, mais le jour où elle
		 en aura, le piège serait revenu (il a coûté un aller-retour sur les
		 CTA). */
	  var presse = parseFloat(jeton(el, '--mm-slider-arrow-press', ''));
	  if (!isFinite(presse)) presse = PRESSE_REPLI;
	  var anim = el.animate(
		[{ transform: 'scale(' + presse + ')' }, { transform: 'scale(1)' }],
		{
		  duration: enMs(jeton(el, '--mm-duration-slow', '650ms'), 650),
		  easing: jeton(el, '--mm-curve-big', 'cubic-bezier(0.30, 1.90, 0.44, 1)'),
		  composite: 'add'
		}
	  );
	  el.__mmRebond = anim;
	  anim.addEventListener('finish', function () { if (el.__mmRebond === anim) el.__mmRebond = null; });
	}
  
	/* La flèche entière, pas seulement celles qui pilotent un slider : les
	   démos de variantes n'ont pas d'attribut de relais et se retrouvaient sans
	   aucun retour au clic (retour Killian). L'enfoncement appartient au bouton. */
	function fleche(cible) {
	  return cible && cible.closest ? cible.closest('.mm-slider-arrow') : null;
	}
  
	document.addEventListener('pointerdown', function (e) {
	  var btn = fleche(e.target);
	  if (btn && !btn.disabled) enfoncer(btn);
	});
	/* Relâchement OU sortie du bouton : sans le second, une flèche gardée
	   enfoncée puis quittée resterait écrasée pour toujours. */
	['pointerup', 'pointercancel'].forEach(function (type) {
	  document.addEventListener(type, function (e) {
		var btn = fleche(e.target);
		if (btn) relacher(btn);
		else document.querySelectorAll('.mm-slider-arrow.is-pressed').forEach(relacher);
	  });
	});
	document.addEventListener('pointerout', function (e) {
	  var btn = fleche(e.target);
	  if (btn) relacher(btn);
	});
  
	/* Le clavier n'émet pas d'événements de pointeur : Entrée et Espace tiennent
	   la flèche enfoncée tant que la touche reste appuyée, comme le doigt. */
	document.addEventListener('keydown', function (e) {
	  if (e.key !== 'Enter' && e.key !== ' ') return;
	  var btn = fleche(e.target);
	  if (btn && !btn.disabled) enfoncer(btn);
	});
	document.addEventListener('keyup', function (e) {
	  if (e.key !== 'Enter' && e.key !== ' ') return;
	  var btn = fleche(e.target);
	  if (btn) relacher(btn);
	});
  
	document.addEventListener('click', function (e) {
	  var btn = e.target.closest('[data-slider-prev], [data-slider-next]');
	  if (!btn || btn.disabled) return;
	  var wrap = btn.closest('[data-mm-slider-arrows]');
	  var targetId = (wrap && wrap.getAttribute('data-slider-target')) || btn.getAttribute('data-slider-target');
	  if (!targetId) return;
	  var target = document.getElementById(targetId);
	  if (!target) return;
	  var isNext = btn.hasAttribute('data-slider-next');
	  target.dispatchEvent(new CustomEvent(isNext ? 'mm:slider:next' : 'mm:slider:prev'));
	});
  })();